/* Comportamentos da camada Amazon.
   Tudo aqui é progressivo: se o JS falhar, a página continua comprável. */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     1. CTA fixo no rodapé (mobile)
     Na Amazon a barra aparece quando o botão principal sai da tela e some
     quando ele volta. Uso IntersectionObserver — sem listener de scroll,
     que é o que faz barra fixa engasgar em celular fraco.
     ---------------------------------------------------------------------- */
  function stickyCta(tentativa) {
    tentativa = tentativa || 0;
    var bar = document.querySelector('[data-ca-sticky]');
    var realBtn = document.querySelector('product-form-component button[name="add"], form[action*="/cart/add"] button[name="add"]');

    // O Horizon hidrata <add-to-cart-component> depois do DOMContentLoaded, e
    // no primeiro init o botão ainda não existe. Reobserva por até ~3s em vez
    // de desistir em silêncio — que era o bug: a barra nunca ligava.
    if (!bar || !realBtn) {
      if (tentativa < 12) setTimeout(function () { stickyCta(tentativa + 1); }, 250);
      return;
    }
    if (bar.dataset.caLigada === '1') return;
    bar.dataset.caLigada = '1';

    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-on', !e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0 });

    io.observe(realBtn);

    // O botão da barra não duplica lógica de carrinho: ele aciona o real.
    var proxy = bar.querySelector('[data-ca-sticky-add]');
    if (proxy) {
      proxy.addEventListener('click', function (ev) {
        ev.preventDefault();
        realBtn.click();
      });
    }
  }

  /* ----------------------------------------------------------------------
     2. Galeria — dica de arraste
     A Amazon mostra os dots e deixa óbvio que dá para arrastar. O Horizon já
     entrega swipe; aqui só marco o container para o CSS poder dar o affordance
     (recorte do próximo slide) sem mexer no componente do tema.
     ---------------------------------------------------------------------- */
  function galleryHint() {
    var g = document.querySelector('.product-media-container, media-gallery-component, [class*="media-gallery"]');
    if (g) g.setAttribute('data-ca-gallery', '');
  }

  function init() {
    stickyCta();
    galleryHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Horizon troca seções por morph no editor e em navegação; re-liga.
  document.addEventListener('shopify:section:load', init);
})();
